const refs = {
    navigation : null 
}


export default refs;